import { AppFeaturesConfig, Feature } from '@ssar-app/domain';
import { createContext, useContext } from 'react';

export type UiAppConfig = AppFeaturesConfig & {
  currentFeatureCode?: string;
  getCurrentFeature: () => Feature | undefined | null;
  setCurrentFeatureCode: (code: string) => void;
};

const AppConfigContext = createContext<UiAppConfig | undefined>(undefined);

const AppConfigContextProvider = AppConfigContext.Provider;

export const useAppConfigContext = (): UiAppConfig => {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error('AppConfigContext was not fond in hierarchy');
  }
  return context;
};

export { AppConfigContextProvider as AppConfigContext };
